/** @jsxImportSource @emotion/react */
import React from 'react';
import { Form, Input, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import type { PlantingMetadata } from '../types';
import { formStyles } from '../constants';

interface MetadataSectionProps {
  metadata: PlantingMetadata;
}

/** Read-only display of planting creation/status metadata (edit mode only) */
const MetadataSection: React.FC<MetadataSectionProps> = ({ metadata }) => {
  const { t } = useTranslation('plantings');
  return (
  <>
    <Typography.Title level={5} css={formStyles.modalTitle}>
      {t('form.metadata.title')}
    </Typography.Title>
    <Form.Item label={t('form.metadata.plantingId')}>
      <Input value={metadata.plantingId ?? '—'} readOnly />
    </Form.Item>
    <Form.Item label={t('form.metadata.createdAt')}>
      <Input value={metadata.createdAt ?? '—'} readOnly />
    </Form.Item>
    <Form.Item label={t('form.metadata.createdBy')}>
      <Input value={metadata.createdBy ?? '—'} readOnly />
    </Form.Item>
    <Form.Item label={t('form.metadata.statusChangedAt')}>
      <Input value={metadata.statusChangedAt ?? '—'} readOnly />
    </Form.Item>
    <Form.Item label={t('form.metadata.statusChangedBy')}>
      <Input value={metadata.statusChangedBy ?? '—'} readOnly />
    </Form.Item>
    <Typography.Title level={5} css={formStyles.sectionTitle}>
      {t('form.metadata.basics')}
    </Typography.Title>
  </>
  );
};

export default MetadataSection;
